module.exports = __webpack_public_path__ + "img/role3.28ac7b5d.png";